import React from "react";
import "../../../../styles/styles.css";
const Cards = ({ title, image, isActive, onClick, index }) => {
  return (
    <div onClick={onClick} className={`card-item ${isActive ? "active" : ""}`}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className="card-image"
        src={require("../../../../assets/video/video" + index + ".mp4")}
      ></video>
    </div>
  );
};

export default Cards;
